var DevOps = "DevOps";
var Gaming = "ゲーム";
var Migration = "移行";
var Other = "その他";
var useCase = {
	"Use case": "ユースケース",
	"AI & machine learning": "AI と機械学習",
	"Batch processing": "バッチ処理",
	"Big data, analytics, & business intelligence": "ビッグデータ、分析、ビジネスインテリジェンス",
	"Business applications - Microsoft": "ビジネスアプリケーション – Microsoft",
	"Business applications - Oracle": "ビジネスアプリケーション – Oracle",
	"Business applications - Other": "ビジネスアプリケーション – その他",
	"Business applications - SAP": "ビジネスアプリケーション – SAP",
	"Content delivery": "コンテンツ配信",
	DevOps: DevOps,
	Gaming: Gaming,
	"Internet of things": "IoT",
	"Learning & certification": "トレーニングと認定",
	"Media services": "メディアサービス",
	Migration: Migration,
	"Mobile applications": "モバイルアプリケーション",
	Other: Other,
	"Storage & backup": "ストレージとバックアップ",
	"Websites & web apps": "ウェブサイトとウェブアプリ"
};

export { DevOps, Gaming, Migration, Other, useCase as default };
